export enum CredentialStatusLabelColor {
  Green,
  Yellow,
  Red,
  Blue,
  Gray
}
